// extracted by mini-css-extract-plugin
export var phone = "_35-0";
export var phoneDragging = "_35-1";